


















import { Vue, Component } from 'nuxt-property-decorator';
import * as pages from '@/constants/pages';
import CloseIcon from '~/assets/svg/close.vue.svg';

const EXCLUDED_URLS = [
  pages.JOBS_MY_MATCHES_PAGE.name,
  pages.JOBS_ONBOARDING_PAGE.name,
  pages.JOBS_ONBOARDING_STEPSLUG_PAGE.name,
  pages.ONBOARDING_V3_PAGE.name,
  pages.ONBOARDING_V3_STEPSLUG_PAGE.name,
  pages.CONNECTIONS_CONTACT_PAGE.name,
  pages.CONNECTIONS_SYNC_PAGE.name,
  pages.SEARCH_IMAGE_PREVIEW_PAGE.name,
  pages.REFERRAL_PRE_ONBOARDING_PAGE.name,
  pages.REFERRAL_PROMOTION_PAGE.name,
  'login-external',
];

const TOP_NOTIFICATION_LOCAL_STORAGE_KEY = 'hide-top-notification-salesgpt';

@Component<TopNotification>({
  components: {
    CloseIcon,
  },
})
export default class TopNotification extends Vue {
  private isClosed = false;

  onTopBannerClick() {
    this.$analytics.logEvent('global__top-banner__click');
  }

  handleClose() {
    localStorage.setItem(TOP_NOTIFICATION_LOCAL_STORAGE_KEY, 'true');
    this.isClosed = true;
  }

  get isVisible() {
    const hideTopNotification = process.client && localStorage.getItem(TOP_NOTIFICATION_LOCAL_STORAGE_KEY);

    if (hideTopNotification || (this.$route.name && EXCLUDED_URLS.includes(this.$route.name))) return false;

    return !this.isClosed;
  }
}
